import React from 'react'
import '../Css/styles2.css'
import '../Css/bootstrap.css'
// import '../css/animate/animate.css'
// import '../css/animate/animate.min.css'

function TopBar() {
    return (
        <div>
            <div className="container-fluid bg-dark py-2 d-none d-md-flex topbar-main">
                <div className="container">
                    <div className="d-flex justify-content-between topbar">
                        <div className="top-info">
                            <small className="me-3 text-white-50"><a href="#"><i className="fas fa-envelope me-2 text-secondary" /></a> <a className='text-secondary' href="mailto:contact@upsys.in">contact@upsys.in</a></small>
                        </div>
                        {/* <div id="note" class="text-secondary d-none d-xl-flex"><small>Note : We help you to Grow your
                  Business</small></div> */}
                        <div className="top-link">
                            <a href="https://www.facebook.com/profile.php?id=100094900818238&mibextid=ZbWKwL" className="topBar-icon bg-light nav-fill btn btn-sm-square rounded-circle"><i className="fab fa-facebook-f text-primary" /></a>

                            {/* <a href="" class="bg-light nav-fill btn btn-sm-square rounded-circle"><i
                      class="fab fa-twitter text-primary"></i></a> */}
                            <a href="https://instagram.com/upsys.in?igshid=MzRlODBiNWFlZA==" className="topBar-icon bg-light nav-fill btn btn-sm-square rounded-circle"><i className="fab fa-instagram text-primary" /></a>

                            <a href="https://www.linkedin.com/company/upsys-it-and-marketing-solutions/" className="topBar-icon bg-light nav-fill btn btn-sm-square rounded-circle me"><i className="fab fa-linkedin-in text-primary" /></a>

                            <a href="http://wa.me/+918871091864" className="topBar-icon bg-light nav-fill btn btn-sm-square rounded-circle"><i className="fab fa-whatsapp text-success"></i></a>

                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default TopBar